import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {translateApiUrl} from '../../../api.urls';


export class CustomTranslateLoader implements TranslateLoader {
    contentHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' });
    public translateApiUrl = translateApiUrl;

    constructor(private http: HttpClient, public route: string) { }

    getTranslation(lang: string): Observable<any> {
      // TODO: Eguzkilore use this project translations url
        /*return this.http.get(
            this.translateApiUrl + this.route,
            {
                params: {
                    languageCode: lang
                },
                headers: this.contentHeader
            }
        ).pipe(
            map((response: any) => JSON.parse(response.data))
        );*/
        return of({});
    }
}
